/**
 * getBilateralTradeRecap Connect RPC 接続 hook。
 *
 * Recap モーダルで 1 件の取引詳細 (BilateralTradeRecap) を取得する。
 *
 * multitenant 規約: organization_id は BFF が eauth セッションから補完する。
 * frontend は organization_id を渡さない。
 */
import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import type { BilateralTradeRecap } from '@ebalance/proto/bffuser/v1/supply_bilateral_trade_model_pb'
import { getBilateralTradeRecap } from '@ebalance/proto/bffuser/v1/supply_bilateral_trade_service-SupplyBilateralTradeService_connectquery'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * GetBilateralTradeRecap RPC から Recap 詳細を取得する hook。
 *
 * @param id 取引 UUID。undefined または空文字の場合は query を実行しない (= enabled=false)。
 */
export function useGetBilateralTradeRecap(
  id: string | undefined,
): UseQueryResult<{ recap?: BilateralTradeRecap }, ConnectError> {
  return useQuery(
    getBilateralTradeRecap,
    { id: id ?? '' },
    { enabled: id !== undefined && id !== '' },
  )
}
